// @@replace logic
require('./_fix-re-wks')('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/core-js/modules/es6.regexp.replace.js
// module id = ../../../../core-js/modules/es6.regexp.replace.js
// module chunks = 0